import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Card       from "@react/shared/ui/Card"
import EmptyState from "@react/shared/ui/EmptyState"

const GRID = "40px 140px minmax(220px,1fr) 80px 120px 120px 120px"
const fmt = m => (m && m.formatted) || "—"

const LinesSection = ({ lines, paths }) => (
  <Card className="rounded-lg">
    <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200">
      <div>
        <h2 className="text-base font-semibold text-slate-900">
          {I18n.t("mbc_contracts.mbc_lines.title")}
        </h2>
        <p className="text-xs text-slate-500 mt-0.5">
          {lines.length} {lines.length === 1 ? "ligne" : "lignes"}
        </p>
      </div>
      {paths.lines && (
        <a
          href      = {paths.lines}
          className = "inline-flex items-center gap-2 h-8 px-3 rounded-md bg-white border border-slate-200 text-xs font-medium text-slate-700 hover:bg-slate-50"
        >
          <FontAwesomeIcon icon="pen-to-square" className="text-[11px]" />
          {I18n.t("mbc_contracts.mbc_lines.manage", { defaultValue: "Gérer" })}
        </a>
      )}
    </div>

    {lines.length === 0 ? (
      <EmptyState size="lg">
        {I18n.t("mbc_contracts.mbc_lines.none", { defaultValue: "Aucune ligne" })}
      </EmptyState>
    ) : (
      <div>
        <div
          className = "grid items-center gap-x-3 px-4 py-3 border-b border-slate-200 bg-slate-50/50 uppercase tracking-wider text-[11px] font-medium text-slate-500"
          style     = {{ gridTemplateColumns: GRID }}
        >
          <div className="text-center">{I18n.t("mbc_contracts.mbc_lines.columns.favorite", { defaultValue: "Fav." })}</div>
          <div>{I18n.t("mbc_contracts.mbc_lines.columns.ref")}</div>
          <div>{I18n.t("mbc_contracts.mbc_lines.columns.label")}</div>
          <div className="text-center">{I18n.t("mbc_contracts.mbc_lines.columns.unit")}</div>
          <div className="text-right">{I18n.t("mbc_contracts.mbc_lines.columns.cost")}</div>
          <div className="text-right">{I18n.t("mbc_contracts.mbc_lines.columns.sale_price")}</div>
          <div className="text-right">{I18n.t("mbc_contracts.mbc_lines.columns.margin")}</div>
        </div>

        {lines.slice(0, 15).map(line => (
          <div
            key       = {line.id}
            className = "grid items-center gap-x-3 px-4 py-2.5 border-b border-slate-100 last:border-b-0 hover:bg-slate-50/60"
            style     = {{ gridTemplateColumns: GRID }}
          >
            <div className="text-center">
              {line.favorite && (
                <FontAwesomeIcon icon="star" className="text-amber-400 text-[13px]" />
              )}
            </div>
            <div className="text-sm font-mono text-slate-800 tabular-nums truncate">{line.code}</div>
            <div className="text-sm text-slate-800 truncate">{line.label}</div>
            <div className="text-center text-xs text-slate-500">{line.unit}</div>
            <div className="text-right text-sm text-slate-700 tabular-nums">{fmt(line.purchase_price)}</div>
            <div className="text-right text-sm text-slate-900 tabular-nums font-medium">{fmt(line.unit_price)}</div>
            <div className={`text-right text-sm tabular-nums font-medium ${line.margin_positive ? "text-emerald-600" : "text-rose-600"}`}>
              {fmt(line.margin)}
            </div>
          </div>
        ))}

        {lines.length > 15 && (
          <div className="px-4 py-3 text-right border-t border-slate-100">
            <a href={paths.lines} className="text-sm text-brand-600 hover:text-brand-700">
              {I18n.t("mbc_contracts.mbc_lines.see_all", {
                count: lines.length,
                defaultValue: `Voir les ${lines.length} lignes`
              })}
            </a>
          </div>
        )}
      </div>
    )}
  </Card>
)

export default LinesSection
